import { REQUEST } from 'utils/actionGenerator';
import { takeLatest } from 'redux-saga/effects';
import * as api from './api';
import { fetchEntitySpawn } from 'store/saga';
import * as tripTabActions from './actions';

export function* getAddressDetails(action) {
  const { demandId } = action.params;
  const request = api.getAddressDetailsRequest(demandId);
  yield fetchEntitySpawn(request, tripTabActions.getAddressDetails, demandId);
}
export function* getAddressDetailsV4(action) {
  const { demandId } = action.params;
  const request = api.getAddressDetailsRequestV4(demandId);
  yield fetchEntitySpawn(request, tripTabActions.getAddressDetailsV4, demandId);
}
export function* updateAddress(action) {
  const { addressId, payload } = action.params;
  const request = api.patchAddressV4(addressId, payload);
  yield fetchEntitySpawn(request, tripTabActions.updateAddress, {
    toaster: { successMsg: 'Request successful', errorMsg: '' },
    payload,
  });
}

export function* submitNewAddresses(action) {
  const { demandId, payload } = action.params;
  const request = api.addAddresses(demandId, payload);
  yield fetchEntitySpawn(request, tripTabActions.submitNewAddressesV4, demandId);
}
export function* deleteAddress(action) {
  const { id } = action.params;
  const request = api.deleteAddressV4(id);
  yield fetchEntitySpawn(request, tripTabActions.submitNewAddressesV4, {
    toaster: { successMsg: `${id} - Address Deleted`, errorMsg: '' },
  });
}
export function* getViaPoints(params) {
  const request = api.getViaPointsRequest(params);
  yield fetchEntitySpawn(request, tripTabActions.getViaPoints, params);
}

export function* createViaPoint(payload) {
  const request = api.createViaPointRequest(payload);
  yield fetchEntitySpawn(request, tripTabActions.createViaPoint, {
    toaster: { successMsg: 'Via Point created succesfully', errorMsg: '' },
    payload,
  });
}

export function* createNewAddress(payload) {
  const request = api.createNewAddressRequest(payload);
  yield fetchEntitySpawn(request, tripTabActions.createNewAddress, {
    toaster: { successMsg: 'Address created succesfully', errorMsg: '' },
    payload,
  });
}

export function* editAddress(payload) {
  const request = api.editAddressRequest(payload);
  yield fetchEntitySpawn(request, tripTabActions.editAddress, {
    toaster: { successMsg: 'Address edited succesfully', errorMsg: '' },
    payload,
  });
}

export function* editViaPoint(payload) {
  const request = api.editViaPointRequest(payload);
  yield fetchEntitySpawn(request, tripTabActions.editViaPoint, {
    toaster: { successMsg: 'Via Point edited succesfully', errorMsg: '' },
    payload,
  });
}

export function* deleteViaPoint(params) {
  const request = api.deleteViaPointRequest(params);
  yield fetchEntitySpawn(request, tripTabActions.deleteViaPoint, {
    toaster: { successMsg: 'Via Point deleted succesfully', errorMsg: '' },
    params,
  });
}

export function* deletePoc(params) {
  const request = api.deletePocRequest(params);
  yield fetchEntitySpawn(request, tripTabActions.deletePoc, {
    toaster: { successMsg: 'Poc deleted succesfully', errorMsg: '' },
    params,
  });
}

export function* editStartPoint(action) {
  const { demandId, payload } = action.payload;
  const request = api.editAddressPointRequest(demandId, payload);
  yield fetchEntitySpawn(request, tripTabActions.editStartPoint, {
    toaster: { successMsg: 'Start Point edited succesfully', errorMsg: '' },
    payload,
  });
}

export function* editEndPoint(action) {
  const { demandId, payload } = action.payload;
  const request = api.editAddressPointRequest(demandId, payload);
  yield fetchEntitySpawn(request, tripTabActions.editEndPoint, {
    toaster: { successMsg: 'End Point edited succesfully', errorMsg: '' },
    payload,
  });
}

export function* editLane(action) {
  const { demandId, payload } = action.payload;
  const request = api.editLaneNameRequest(demandId, payload);
  yield fetchEntitySpawn(request, tripTabActions.editLane, {
    toaster: { successMsg: 'Lane Name edited succesfully', errorMsg: '' },
    payload,
  });
}
export function* selectMapLocation(action) {
  const { placeId } = action.params;
  const setSourceAsGoogle = true;
  const request = api.selectmapLocation(placeId, setSourceAsGoogle);
  yield fetchEntitySpawn(request, tripTabActions.selectMapLocation);
}
function* mySaga() {
  yield takeLatest(tripTabActions.GET_ADDRESS_DETAILS[REQUEST], getAddressDetails);
  yield takeLatest(tripTabActions.GET_ADDRESS_DETAILS_V4[REQUEST], getAddressDetailsV4);
  yield takeLatest(tripTabActions.GET_VIA_POINTS[REQUEST], getViaPoints);
  yield takeLatest(tripTabActions.CREATE_VIA_POINT[REQUEST], createViaPoint);
  yield takeLatest(tripTabActions.EDIT_VIA_POINT[REQUEST], editViaPoint);
  yield takeLatest(tripTabActions.EDIT_START_POINT[REQUEST], editStartPoint);
  yield takeLatest(tripTabActions.EDIT_END_POINT[REQUEST], editEndPoint);
  yield takeLatest(tripTabActions.EDIT_LANE[REQUEST], editLane);
  yield takeLatest(tripTabActions.DELETE_VIA_POINT[REQUEST], deleteViaPoint);
  yield takeLatest(tripTabActions.CREATE_NEW_ADDRESS[REQUEST], createNewAddress);
  yield takeLatest(tripTabActions.EDIT_ADDRESS[REQUEST], editAddress);
  yield takeLatest(tripTabActions.DELETE_POC[REQUEST], deletePoc);
  yield takeLatest(tripTabActions.UPDATE_ADDRESS[REQUEST], updateAddress);
  yield takeLatest(tripTabActions.SELECT_MAP_LOCATION[REQUEST], selectMapLocation);
  yield takeLatest(tripTabActions.SUBMIT_NEW_ADDRESSES_V4[REQUEST], submitNewAddresses);
  yield takeLatest(tripTabActions.DELETE_ADDRESS_V4[REQUEST], deleteAddress);
}

export default mySaga;
